import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=4f3c60fd&scoped=true&"
import script from "./section6.vue?vue&type=script&lang=js&"
export * from "./section6.vue?vue&type=script&lang=js&"
import style0 from "./section6.vue?vue&type=style&index=0&id=4f3c60fd&lang=scss&scoped=true&"
import style1 from "./section6.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c60fd",
  null
  
)

export default component.exports